import Plot from "react-plotly.js"
import "./style.scss"

const COLORS = [
  'rgb(255, 246, 114)',
  'rgb(255, 155, 144)',
  'rgb(132, 239, 218)',
  'rgb(182, 223, 255)',
  'rgb(180, 223, 196, .2)',
  'rgb(34, 127, 74, .2)'
]

const COLORS_OPACITY = [
  'rgb(233, 208, 105)',
  'rgb(228, 139, 129)',
  'rgb(111, 201, 183)',
  'rgb(164, 201, 228)',
  'rgb(180, 223, 196, .2)',
  'rgb(34, 127, 74, .2)'
]


export const PieRecharts2 = ({ data1, data2, title }) => {
  const isEqual = JSON.stringify(data1) === JSON.stringify(data2)
  const hasReferenceData = data2.find(item => item.value !== 0);

  const checkDate = data1.some(item => item.name.includes('Referência')) || isEqual ? {hole: 0.7} : {}
  const checkDate2 = data2.some(item => item.name.includes('Referência')) ? {hole: 0.7} : {}

  const data2Chart = [
    {
      values: data1.map(({ value }) => value),
      labels: data1.map(({ name }) => name),
      type: "pie",
      ...checkDate,
      name: '',
      domain: {
        x: (hasReferenceData && !isEqual) ? [0.25, 0.75] : [],
        y: (hasReferenceData && !isEqual) ? [0.25, 0.75] : [],
      },
      marker: {
        colors: COLORS,
      },
      hoverinfo: 'label+value+percent+name',
    },
    {
      values: data2.map(({ value }) => value),
      labels: data2.map(({ name }) => name),
      type: "pie",
      name: '',
      ...checkDate2,
      // domain: {
      //   x: [0.2, 0.8],
      //   y: [0.2, 0.8],
      // },
      marker: {
        colors: COLORS_OPACITY
      },
      hoverinfo: 'label+value+percent+name',
    }
  ];

  return (
    <Plot
      data={data2Chart}
      layout={{
        title: { text: title || "" }, showlegend: true,
        legend: {orientation:'h', x: 0.5, y: -.3, xanchor: 'center', yanchor: 'bottom', font: { family: 'Montserrat, sans- serif' } },
        height: 600,
        width: 700,
        margin: { l: 0, r: 0, t: 50, b: 20 },
      }}
    />
  )
}
